<button [class]='style' *ngIf='!expanded' (click)='expanded = true' aria-label="הצגת עוד מסננים אופציונליים">עוד ({{count}})</button>